import { render, staticRenderFns } from "./DeductionsTable.vue?vue&type=template&id=60bbb9a8&lang=pug&"
import script from "./DeductionsTable.vue?vue&type=script&lang=js&"
export * from "./DeductionsTable.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60bbb9a8')) {
      api.createRecord('60bbb9a8', component.options)
    } else {
      api.reload('60bbb9a8', component.options)
    }
    module.hot.accept("./DeductionsTable.vue?vue&type=template&id=60bbb9a8&lang=pug&", function () {
      api.rerender('60bbb9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayouts/DeductionsTable.vue"
export default component.exports